import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
// import { AngularFireStorage, AngularFireStorageReference, AngularFireUploadTask } from 'angularfire2/storage';
import { AngularFireStorage, AngularFireStorageReference, AngularFireUploadTask } from '@angular/fire/compat/storage';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ClaimService } from '../claim.service';
import { Claim } from '../claim';
import { UserService } from '../loginCore/user.service';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';


@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.css']
})

export class FileUploadComponent implements OnInit {

    @ViewChild('myInput',{static: false})
    myInputVariable: ElementRef;

    ref: AngularFireStorageReference;
    task: AngularFireUploadTask;
    uploadState: Observable<string>;
    uploadProgress: Observable<number>;
    downloadURL: Observable<string>;
    path: string = 'tmp//';
    claimDetail: Claim;
    imageToShow: any;

    constructor(
        private afStorage: AngularFireStorage,
        private claimService: ClaimService,
        public userService: UserService,
        public snackBar: MatSnackBar
    ) { }

    ngOnInit() {
        if (this.claimService.getClaimInformation() === undefined) {
            this.claimDetail = JSON.parse(localStorage.getItem('claimObj'));
        } else {
            this.claimDetail = this.claimService.getClaimInformation();
            localStorage.setItem('claimObj', JSON.stringify(this.claimDetail));
        }
        this.userService.getHRRole();
    }

    isHRRole() {
        return this.userService.isHR;
    }

    upload(event) {
        const id = Math.random().toString(36).substring(2);
        this.ref = this.afStorage.ref(this.path + id);
        this.task = this.ref.put(event.target.files[0]);
        this.uploadProgress = this.task.percentageChanges();
        this.task.snapshotChanges().pipe(
            finalize(() => {
                this.ref.getDownloadURL().subscribe(url => {
                    this.claimService.attachClaimReceipt(this.claimDetail.claimId, url)
                        .subscribe(claimResult => {
                            this.claimDetail = claimResult;
                            this.claimService.setClaimInformation(claimResult);
                            localStorage.setItem('claimObj', JSON.stringify(claimResult));
                            this.openSnackbar('Attachment has been uploaded successfully.');
                            console.log(this.myInputVariable.nativeElement.files);
                            this.myInputVariable.nativeElement.value = "";
                            console.log(this.myInputVariable.nativeElement.files);
                        })
                });
            }))
            .subscribe();
    }

    getAttachment(url) {
        const regex = /id=(\d+)/;
        const match = url.match(regex);
        let id;
        if (match) {
            id = match[1];
        } else {
            console.log("No id found in the input string.");
            return;
        }

        // Open the tab synchronously (inside the click handler) so it isn't blocked by
        // popup blockers. We'll navigate it to the blob URL once the file is downloaded.
        const newTab = window.open('', '_blank');

        this.claimService.getAttachment(id).subscribe(response => {
            const contentType = response.headers.get('Content-Type') || 'application/octet-stream';
            const fileName = this.extractFileName(response.headers.get('Content-Disposition'));
            const blob = new Blob([response.body], { type: contentType });
            const blobUrl = window.URL.createObjectURL(blob);

            // Types the browser can typically render inline in a new tab.
            const isRenderableInline = /^(application\/pdf|image\/|text\/plain)/i.test(contentType);

            if (isRenderableInline) {
                if (newTab) {
                    newTab.location.href = blobUrl;
                } else {
                    // Popup was blocked - fall back to opening in the same context.
                    window.open(blobUrl, '_blank');
                }
                setTimeout(() => window.URL.revokeObjectURL(blobUrl), 60000);
            } else {
                // Not renderable inline (e.g. Office documents) - force a proper download
                // with the correct filename/extension instead of leaving a blank/blocked tab.
                if (newTab) {
                    newTab.close();
                }
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = fileName || 'attachment';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setTimeout(() => window.URL.revokeObjectURL(blobUrl), 60000);
            }
        }, error => {
            if (newTab) {
                newTab.close();
            }
            console.log(error);
            this.openAlertSnackbar('Unable to open the attachment. Please try again.');
        });
    }

    private extractFileName(contentDisposition: string | null): string | null {
        if (!contentDisposition) {
            return null;
        }
        const match = /filename\*?=(?:UTF-8''|")?([^";]+)"?/i.exec(contentDisposition);
        return match ? decodeURIComponent(match[1]) : null;
    }


    delete(keyString) {
        this.claimService.deleteAttachment(keyString).subscribe(
            claimResult => {
                this.claimDetail = claimResult;
                this.claimService.setClaimInformation(claimResult);
                localStorage.setItem('claimObj', JSON.stringify(claimResult));
                this.openSnackbar('Attachment has been deleted successfully.');
            }), error => {
                this.openAlertSnackbar('Error occured. Failed to delete the attachment. ' + error);
            }
    }

    openSnackbar(msg: string) {
        this.snackBar.open(msg, "Got it!",
            {
                duration: 3000
            });
    }

    openAlertSnackbar(msg: string) {
        this.snackBar.open(msg, "Dismiss",
            {
                duration: 10000,
                panelClass: ["snack-error"]
            });
    }
    isFirebaseUrl(fileIdOrUrl: string): boolean {
        return !!fileIdOrUrl && fileIdOrUrl.startsWith('https://firebasestorage.googleapis.com/');
    }
}
